
import { StorageId, FormState__startLoading, FormState_get_empty, RequestedValue$1 } from "../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../CommunicationV2.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { RemoveQrCodesDto_$reflection, RemoveQrCodesDto, StorageDetailDto_$reflection } from "../../Shared/Storage.js";
import { ValidationOnGetRequest } from "../../ErrorHandling.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unwrapStorageId } from "../../Shared/Helper.js";
import { Cmd_batch, Cmd_none } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { StorageId__get_unwrap } from "../../Shared/Shared.js";
import { parse } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { defaultOf } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { Auto_generateBoxedEncoder_437914C6, toString } from "../../fable_modules/Thoth.Json.10.4.1/Encode.fs.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export function initViewStorageView(storageId) {
    return [new State(storageId, new RequestedValue$1(0, []), false, FormState_get_empty()), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), StorageDetailDto_$reflection()));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/storages/", unwrapStorageId(storageId), ..."/details"), (Item) => (new Msg(7, [Item])), (Item_1) => (new Msg(9, [Item_1])))];
}

export function update(msg, state) {
    let dto;
    switch (msg.tag) {
        case 1:
            return [new State(state.StorageId, state.Storage, false, state.FormState), Cmd_none()];
        case 2: {
            const matchValue = state.Storage;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [new State(state.StorageId, state.Storage, state.IsDeleteDialogOpen, FormState__startLoading(state.FormState)), Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), concat("/api/storages/", ...StorageId__get_unwrap(new StorageId(parse(matchValue.fields[0].Id)))), (Item_1) => (new Msg(8, [Item_1])), (Item_2) => (new Msg(9, [Item_2])))];
            }
        }
        case 3:
            return [state, Cmd_OfPromise_either((tupledArg) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_5;
                return ((url_5 = addPrefix(tupledArg[0]), (refreshOn_1) => fetchWithDecoder(url_5, ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(2, [tupledArg[1]])]), "application/json", (response_2) => {
                    const pr_1 = response_2.arrayBuffer();
                    return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), string_type));
                }, refreshOn_1)))(true);
            })), [concat("/api/storages/", StorageId__get_unwrap(state.StorageId), "/qr-codes/", ...window.encodeURIComponent(msg.fields[0])), defaultOf()], (Item_3) => (new Msg(5, [Item_3])), (Item_4) => (new Msg(9, [Item_4])))];
        case 4:
            return [state, (dto = (new RemoveQrCodesDto(msg.fields[0])), Cmd_OfPromise_either((tupledArg_1) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_8;
                return ((url_8 = addPrefix(tupledArg_1[0]), (refreshOn_2) => fetchWithDecoder(url_8, ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(2, [tupledArg_1[1]])]), "application/json", (response_4) => {
                    const pr_2 = response_4.arrayBuffer();
                    return pr_2.then((blob_2) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_2)), string_type));
                }, refreshOn_2)))(true);
            })), [concat("/api/storages/", StorageId__get_unwrap(state.StorageId), ..."/qr-codes"), toString(0, Auto_generateBoxedEncoder_437914C6(RemoveQrCodesDto_$reflection(), undefined, undefined, undefined)(dto))], (Item_5) => (new Msg(5, [Item_5])), (Item_6) => (new Msg(9, [Item_6]))))];
        case 5:
            if (msg.fields[0].tag === 1) {
                return [state, Cmd_batch(ofArray([singleton((dispatch_1) => {
                    dispatch_1(new Msg(6, []));
                }), Cmd_errorToast("validation.toast")]))];
            }
            else {
                return [state, singleton((dispatch) => {
                    dispatch(new Msg(6, []));
                })];
            }
        case 6:
            return [state, Cmd_OfPromise_either((url_9) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                let url_11;
                return ((url_11 = addPrefix(url_9), (refreshOn_3) => fetchWithDecoder(url_11, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_7) => {
                    const pr_3 = response_7.arrayBuffer();
                    return pr_3.then((blob_3) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_3)), StorageDetailDto_$reflection()));
                }, refreshOn_3)))(true).then((_arg) => {
                    const result_4 = _arg;
                    return (result_4.tag === 1) ? (Promise.resolve((() => {
                        throw new ValidationOnGetRequest(result_4.fields[0]);
                    })())) : (Promise.resolve(result_4.fields[0]));
                });
            })), concat("/api/storages/", unwrapStorageId(state.StorageId), ..."/details"), (Item_7) => (new Msg(7, [Item_7])), (Item_8) => (new Msg(9, [Item_8])))];
        case 7:
            return [new State(state.StorageId, new RequestedValue$1(1, [msg.fields[0]]), state.IsDeleteDialogOpen, state.FormState), Cmd_none()];
        case 8: {
            const response_10 = msg.fields[0];
            const closedState = new State(state.StorageId, state.Storage, false, FormState_get_empty());
            if (response_10.tag === 1) {
                return [closedState, Cmd_errorToast(defaultArg(response_10.fields[0].GlobalValidationMessage, "validation.toast"))];
            }
            else {
                return [closedState, Cmd_batch(ofArray([Cmd_ofEffect((_arg_1) => {
                    RouterModule_nav(singleton("storages"), 1, 1);
                }), Cmd_successToast("general.saved_successfully")]))];
            }
        }
        case 9:
            return [new State(state.StorageId, state.Storage, false, FormState_get_empty()), Cmd_errorToast("storage.fail_fetch_data")];
        default:
            return [new State(state.StorageId, state.Storage, true, state.FormState), Cmd_none()];
    }
}

